import { useMutation } from "@tanstack/react-query";
import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { Modal } from "../../components";

interface Props {
  userId: number
  isOpen: boolean
  onClose: () => void
}

const ResetConfirmationModal = (props: Props) => {
  const resetMutation = useMutation(window.CoreApi.User.ResetPassword)
  const onReset = async () => {
    resetMutation.mutateAsync(props.userId);
  }

  const hasServerError = resetMutation.data?.data.hasErrors
  const wasSuccessful = resetMutation.data?.data.data != null;
  const hasError = resetMutation.isError;

  return <Modal
    isOpen={props.isOpen}
    handleClose={props.onClose}
    width="tiny"
    title={RESX.Account.ResetPassword}
  >
    {hasError && <div className="ui red">
      {RESX.GeneralLabels.SomethingUnexpectedHappened}
    </div>}

    {hasServerError && <div className="ui red">
      {resetMutation.data?.data.errors.join("\n")}
    </div>}

    {wasSuccessful && <>
      <div dangerouslySetInnerHTML={{ __html: resetMutation.data.data.data }} />

      <div className="flex">
        <div className="grow1"></div>
        <div>
          <ButtonPrimary label={RESX.Buttons.BtnOk} onClick={props.onClose} />
        </div>
      </div>
    </>}

    {!wasSuccessful && <>
      <div>{RESX.GeneralWarnings.AreYouSure}</div>

      <div className="flex">
        <div className="grow1"></div>
        <div>
          <ButtonPrimary label={RESX.Account.ResetPassword} disabled={resetMutation.isLoading} loading={resetMutation.isLoading} onClick={onReset} />
        </div>
      </div>
    </>}
  </Modal>
}

export default ResetConfirmationModal;